import api from "@/lib/api";
import { useEffect, useState } from "react";

const BADGES = [
  { key: "bank", label: "Bank", cls: "bg-fuchsia-100 text-fuchsia-700" },
  { key: "post", label: "Post", cls: "bg-indigo-100 text-indigo-700" },
  { key: "library", label: "Library", cls: "bg-sky-100 text-sky-700" },
  { key: "catalog", label: "Catalog", cls: "bg-amber-100 text-amber-700" },
  { key: "production", label: "Production", cls: "bg-emerald-100 text-emerald-700" },
  { key: "orders", label: "Orders", cls: "bg-rose-100 text-rose-700" },
];

// Hook: given a list of file_ids, returns a map file_id -> usage flags.
export function useUsage(fileIds) {
  const [usage, setUsage] = useState({});
  const key = (fileIds || []).join(",");
  useEffect(() => {
    const ids = (fileIds || []).filter(Boolean);
    if (!ids.length) { setUsage({}); return; }
    api.post("/marketing/usage", { file_ids: ids }).then(({ data }) => setUsage(data || {})).catch(() => {});
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return usage;
}

export function UsageBadges({ usage, className = "" }) {
  if (!usage) return null;
  const active = BADGES.filter((b) => usage[b.key]);
  if (!active.length) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${className}`} data-testid="usage-badges">
      {active.map((b) => (
        <span key={b.key} className={`text-[9px] font-semibold px-1.5 py-0.5 rounded ${b.cls}`}>{b.label}</span>
      ))}
    </div>
  );
}
